import { getAllGerminatedSeedTransaction, getAllGerminatedSeedTransactionType, getGerminatedSeedTransactionDetail, deleteTransaction } from "@/api/germinated_seed_transaction";

const state = {
    germinatedSeedTransaction: null,
    germinatedSeedTransactionTypes: null,
    germinatedSeedTransactionDetail: null
};

const mutations = {
    GET_ALL: (state, data) => {
        state.germinatedSeedTransaction = data;
    },
    GET_ALL_TYPE: (state, data) => {
        state.germinatedSeedTransactionTypes = data;
    },
    GET_DETAIL: (state, data) => {
        state.germinatedSeedTransactionDetail = data;
    },
};

const actions = {
    async getAllGerminatedSeedTransaction({ commit }, notificationPagination) {
        let res = await getAllGerminatedSeedTransaction({ ...notificationPagination });
        if (res) {
            commit("GET_ALL", res); 
        }
    },

    async getAllGerminatedSeedTransactionType({ commit }) {
        let res = await getAllGerminatedSeedTransactionType();
        if (res) {
            commit("GET_ALL_TYPE", res); 
        }
    },

    async getGerminatedSeedTransactionDetail({ commit }, params) {
        let res = await getGerminatedSeedTransactionDetail(params);
        if (res) {
            commit("GET_DETAIL", res); 
        }
    },

    async deleteTransaction({ commit }, params) {
        let res = await deleteTransaction(params);
        if (res) {
            commit("GET_DETAIL", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/germinated_seed_transaction.js